import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { FiWatch } from 'react-icons/fi';

import { saveDeliveryTime } from '../../../Store/Modules/Store/Actions';
import { Container, Time } from './styles';

function DeliveryTime() {
  const dispatch = useDispatch();
  const { deliveryTime } = useSelector((state) => state.store);
  const [enabled, setEnabled] = useState(deliveryTime.enabled);
  const [time, setTime] = useState(deliveryTime.time);

  function handleChange(event) {
    setTime({ ...time, [event.target.name]: Number(event.target.value) });
  }

  function handleSave() {
    dispatch(saveDeliveryTime({ enabled, time }));
  }

  return (
    <Container>
      <Switch
        color='primary'
        checked={enabled}
        onChange={(event) => setEnabled(event.target.checked)}
      />
      {enabled ? 'Ativado' : 'Desativado'}
      <Time>
        <TextField
          disabled={!enabled}
          size='small'
          style={{ width: '100px' }}
          label='De'
          variant='outlined'
          placeholder='0'
          name='from'
          value={time.from}
          onChange={handleChange}
          type='number'
          InputProps={{
            endAdornment: (
              <InputAdornment position='end'>
                <FiWatch />
              </InputAdornment>
            ),
          }}
        />
        <span></span>
        <TextField
          disabled={!enabled}
          size='small'
          style={{ width: '100px' }}
          label='Até'
          variant='outlined'
          placeholder='0'
          value={time.to}
          type='number'
          onChange={handleChange}
          name='to'
          InputProps={{
            endAdornment: (
              <InputAdornment position='end'>
                <FiWatch />
              </InputAdornment>
            ),
          }}
        />
        <span>minutos</span>
      </Time>
      <hr />
      <Button color='primary' variant='contained' onClick={handleSave}>
        Salvar
      </Button>
    </Container>
  );
}

export default DeliveryTime;
